import React, { useState, useRef, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import { toast } from "sonner";
import {
  fetchAboutUsPage,
  updateAboutUsPage,
  uploadCustomPageMedia,
  uploadBlogInlineImage,
} from "../../services/axios/apiManager";
import { handleErrors, validateImage } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../services/axios/eps";
import LoadingSpinner from "../../Components/spinner";
import $ from "jquery";
import "summernote/dist/summernote-lite.css";
import "summernote/dist/summernote-lite.js";

const Features = ({ data, setAboutUsData }) => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!validateImage(file)) {
        e.target.value = "";
        return;
      }
      const imageUrl = URL.createObjectURL(file);
      setSelectedImage(imageUrl);
      const formData = new FormData();
      formData.append("page_content_id", data?.id);
      formData.append("id", data?.media[0]?.id || null);
      formData.append("section", data?.media[0]?.section || "sec");
      formData.append("image", file);
      const res = await uploadCustomPageMedia(formData);
      if (res?.data?.success) {
        if (res?.data?.data) {
          data.media[0] = res.data.data;
        }
        toast.success("Image has been updated", { autoClose: 2000 });
      } else {
        handleErrors(res, navigate, "Upload Image: ");
      }
    }
  };

  return (
    <div className="col-12 col-md-6">
      <div className="d-flex gap-3 p-3 bg-transparent rounded-3">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            border: "2px solid #fdbb2d",
            overflow: "hidden",
            cursor: "pointer",
            backgroundColor: "#fff",
            flexShrink: 0,
          }}
          onClick={handleImageClick}
        >
          {selectedImage || data?.media[0]?.image ? (
            <img
              crossOrigin="anonymous"
              src={
                selectedImage ||
                `${baseURL}/uploads/file/${data?.media[0]?.image}`
              }
              alt="Uploaded Icon"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
          ) : (
            <span style={{ color: "#fdbb2d", fontSize: "2rem" }}>+</span>
          )}
        </div>
        <input
          type="file"
          accept="image/png, image/jpeg, image/webp"
          style={{ display: "none" }}
          ref={fileInputRef}
          onChange={handleImageChange}
        />
        <span className="text-light small d-block">Max 10MB</span>

        <div style={{ flex: 1 }}>
          <h5
            className="fw-bold"
            contentEditable={true}
            suppressContentEditableWarning={true}
            onBlur={(e) => {
              setAboutUsData((prev) =>
                prev.map((m) =>
                  m.section === data?.section
                    ? { ...m, heading: e.target.innerText }
                    : m,
                ),
              );
            }}
          >
            {data?.heading}
          </h5>
          <p
            className="text-light opacity-75"
            contentEditable={true}
            suppressContentEditableWarning={true}
            onBlur={(e) => {
              setAboutUsData((prev) =>
                prev.map((m) =>
                  m.section === data?.section
                    ? { ...m, content: e.target.innerText }
                    : m,
                ),
              );
            }}
          >
            {data?.content}
          </p>
        </div>
      </div>
    </div>
  );
};

const AboutPage = () => {
  const bannerAboutInputRef = useRef(null);
  const navigate = useNavigate();
  const [aboutUsData, setAboutUsData] = useState([]);
  const [bannerImage, setBannerImage] = useState(null);
  const [mainImage, setMainImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState("");
  const editorRef = useRef(null);
  const isEditorInitialized = useRef(false);
  const contentRef = useRef(""); // Use a ref to store current content without triggering re-renders if not needed

  const handleBannerUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateImage(file)) {
        event.target.value = "";
        return;
      }
      const imageURL = URL.createObjectURL(file);
      setBannerImage(imageURL);
      const temp = aboutUsData.find((m) => m.section === "main-image");
      const formData = new FormData();
      formData.append("page_content_id", temp?.id);
      formData.append("id", temp?.media[0]?.id || null);
      formData.append("section", temp?.media[0]?.section || "sec");
      formData.append("image", file);
      const res = await uploadCustomPageMedia(formData);
      if (res?.data?.success) {
        toast.success("Image has been updated", { autoClose: 2000 });
      } else {
        handleErrors(res, navigate, "Upload Image: ");
      }
    }
  };

  const handleSubmit = async () => {
    const temp = aboutUsData.map((m) => ({
      id: m.id,
      content: m.section === "top" ? content : m.content,
      heading: m.heading,
      status: 1,
    }));
    const res = await updateAboutUsPage(temp);
    if (res?.data?.success) {
      toast.success("About-us page content has been Updated!", {
        duration: 2000,
      });
    } else {
      handleErrors(res, navigate, "About-Us Page: ");
    }
  };

  const getAboutUsPageData = async () => {
    try {
      const res = await fetchAboutUsPage();
      if (res?.data?.success && res?.data?.data) {
        setAboutUsData(res.data.data);
        const mainImg = res.data.data.find((m) => m.section === "main-image");
        setMainImage(mainImg?.media?.[0]?.image);
        const tempContent = res.data.data.find(
          (m) => m.section === "top",
        )?.content;

        if (!isEditorInitialized.current) {
          $(editorRef.current).summernote({
            placeholder: "Enter content...",
            tabsize: 2,
            toolbar: [
              ["style", ["style"]],
              ["font", ["bold", "underline", "clear"]],
              ["color", ["color"]],
              ["para", ["ul", "ol", "paragraph"]],
              ["table", ["table"]],
              ["insert", ["link", "picture", "video"]],
              ["view", ["fullscreen", "codeview", "help"]],
            ],
            callbacks: {
              onChange: function (contents) {
                contentRef.current = contents;
                setContent(contents);
              },
              onImageUpload: function (files) {
                for (let i = 0; i < files.length; i++) {
                  const file = files[i];
                  if (!validateImage(file)) {
                    continue;
                  }
                  const formData = new FormData();
                  formData.append("image", file);
                  uploadBlogInlineImage(formData)
                    .then((res) => {
                      if (res?.data?.success) {
                        const url = `${baseURL}/uploads/file/${res.data.url}`;
                        $(editorRef.current).summernote("insertImage", url);
                      } else {
                        toast.error("Failed to upload inline image");
                      }
                    })
                    .catch((err) => {
                      console.error("Error uploading image:", err);
                      toast.error("Error uploading image");
                    });
                }
              },
            },
          });
          isEditorInitialized.current = true;
        }

        // Always set the code if it's different and handle empty content
        const currentCode = $(editorRef.current).summernote("code");
        const newCode = tempContent || "<p><br></p>";
        if (currentCode !== newCode) {
          $(editorRef.current).summernote("code", newCode);
        }
        setContent(newCode);
        contentRef.current = newCode;

        $(".note-editable").css({
          "background-color": "transparent",
          color: "#fff",
          "min-height": "400px",
        });

        if ($("#summernote-custom-styles").length === 0) {
          $("<style id='summernote-custom-styles'>")
            .prop("type", "text/css")
            .html(
              `
               .note-editable ul {
                 list-style-type: disc !important;
                 padding-left: 40px !important;
               }
               .note-editable ol {
                 list-style-type: decimal !important;
                 padding-left: 40px !important;
               }
               .note-editable li {
                 display: list-item !important;
               }
              `,
            )
            .appendTo("head");
        }

        $(".note-toolbar").addClass("summernote-toolbar");

        setContent(newCode);
        contentRef.current = newCode;
      } else {
        handleErrors(res, navigate, "About-Us Page: ");
      }
    } catch (error) {
      console.log("Error getting data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAboutUsPageData();
    return () => {
      if (isEditorInitialized.current && editorRef.current) {
        $(editorRef.current).summernote("destroy");
        isEditorInitialized.current = false;
      }
    };
  }, []);

  return (
    <DashboardLayout>
      {loading && (
        <div className="constainer-fluid">
          <div className="d-flex justify-content-center align-items-center">
            <LoadingSpinner size={"lg"} />
          </div>
        </div>
      )}
      {!loading && aboutUsData?.length <= 0 && (
        <div className="constainer-fluid">
          <div className="d-flex justify-content-center align-items-center">
            <button
              className="btn btn-success mt-4 mb-3"
              onClick={() => {
                getAboutUsPageData();
              }}
            >
              Refresh
            </button>
          </div>
        </div>
      )}
      <div className="container">
        <section className="py-4 bg-dark text-white mb-5 rounded-md">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-xxl-12">
                <h1
                  className="text-center text-[35px] font-semibold mb-3"
                  contentEditable={true}
                  suppressContentEditableWarning={true}
                  onBlur={(e) => {
                    setAboutUsData((prev) =>
                      prev.map((m) =>
                        m.section === "top"
                          ? { ...m, heading: e.target.innerText }
                          : m,
                      ),
                    );
                  }}
                >
                  {aboutUsData.find((m) => m.section === "top")?.heading || ""}
                </h1>

                <div
                  className="bg-dark text-light border-light input-placeholder-light"
                  ref={editorRef}
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-5 bg-dark text-white rounded-md">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-12 col-lg-6">
                <h2
                  className="fw-bold mt-3 text-center text-lg-start"
                  contentEditable={true}
                  suppressContentEditableWarning={true}
                  onBlur={(e) => {
                    setAboutUsData((prev) =>
                      prev.map((m) =>
                        m.section === "middle"
                          ? { ...m, heading: e.target.innerText }
                          : m,
                      ),
                    );
                  }}
                >
                  {aboutUsData.find((m) => m.section === "middle")?.heading ||
                    ""}
                </h2>
                <div className="row g-4 mt-4">
                  <Features
                    data={aboutUsData.find((m) => m.section === "1st")}
                    setAboutUsData={setAboutUsData}
                  />
                  <Features
                    data={aboutUsData.find((m) => m.section === "2nd")}
                    setAboutUsData={setAboutUsData}
                  />
                  <Features
                    data={aboutUsData.find((m) => m.section === "3rd")}
                    setAboutUsData={setAboutUsData}
                  />
                  <Features
                    data={aboutUsData.find((m) => m.section === "4th")}
                    setAboutUsData={setAboutUsData}
                  />
                </div>
              </div>
              <div className="col-12 col-lg-6 text-center">
                <img
                  crossOrigin="anonymous"
                  className="img-fluid rounded-3"
                  style={{
                    maxWidth: "625px",
                    height: "auto",
                    cursor: "pointer",
                  }}
                  src={bannerImage || `${baseURL}/uploads/file/${mainImage}`}
                  alt="Select Banner"
                  onClick={() => bannerAboutInputRef.current.click()}
                />
                <input
                  type="file"
                  accept="image/png, image/jpeg, image/webp"
                  ref={bannerAboutInputRef}
                  style={{ display: "none" }}
                  onChange={handleBannerUpload}
                />
                <span className="text-light small d-block mt-2">
                  Maximum file size: 10MB
                </span>
              </div>
            </div>
          </div>
        </section>
        <div className="constainer-fluid">
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-success mt-4 mb-3"
              onClick={handleSubmit}
            >
              Update Content
            </button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AboutPage;
